export const mentionRegexp = new RegExp(/{{EMPLOYEE\|\d*}}/, 'ig');
